const Holidays2026 = [
  '05/25/2026', // Memorial Day
  '06/19/2026', // Juneteenth
  '07/03/2026', // Independence Day
  '07/04/2026', // Independence Day
  '09/07/2026', // Labor Day
  '10/12/2026', // Columbus Day
  '11/11/2026', // Veteran's Day
  '11/26/2026', // Thanksgiving Day
  '12/25/2026', // Christmas Day
  '01/01/2027', // New Year's Day
];

export const AttDisabledInstallationDates = [
  '09/01/2025',
  '10/12/2025',
  '11/27/2025',
  '11/28/2025',
  '11/29/2025',
  '12/24/2025',
  '12/25/2025',
  '12/31/2025',
  '01/01/2026',
  '01/19/2026',
  ...Holidays2026,
];

export const CoxDisabledInstallationDates = [
  '09/01/2025',
  '11/27/2025',
  '11/28/2025',
  '11/29/2025',
  '12/24/2025',
  '12/25/2025',
  '12/31/2025',
  '01/01/2026',
  '01/19/2026',
  ...Holidays2026,
];

export const SpectrumDisabledInstallationDates = [
  '07/04/2025',
  '07/05/2025',
  '09/01/2025',
  '09/02/2025',
  '11/27/2025',
  '11/28/2025',
  '11/29/2025',
  '12/24/2025',
  '12/25/2025',
  '12/29/2025',
  '12/30/2025',
  '12/31/2025',
  '01/01/2026',
  '01/19/2026',
  ...Holidays2026,
];

export const XfinityDisabledInstallationDates = [
  '09/01/2025',
  '11/27/2025',
  '11/28/2025',
  '11/29/2025',
  '12/24/2025',
  '12/25/2025',
  '12/31/2025',
  '01/01/2026',
  '01/19/2026',
  ...Holidays2026,
];
